import { render, staticRenderFns } from "./TermsAndConditionsPage.vue?vue&type=template&id=645594f6&scoped=true&"
import script from "./TermsAndConditionsPage.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsPage.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsPage.vue?vue&type=style&index=0&id=645594f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645594f6",
  null
  
)

export default component.exports